import * as Api from '@ViewModels';

/** Get location detail (link, phone number, address, instructions) */
export const getLocationDetail = (location?: Api.IMeetingLocation): string | null => {
	if (!location?._type) return null;
	switch (location._type) {
		case Api.MeetingLocation.Virtual:
			return (location as Api.IVirtualMeetingLocation).link ?? null;
		case Api.MeetingLocation.Phone:
			return (location as Api.IPhoneMeetingLocation).phoneNumber ?? null;
		case Api.MeetingLocation.InPerson:
			return (location as Api.IInPersonMeetingLocation).address ?? null;
		case Api.MeetingLocation.Other:
			return (location as Api.IOtherMeetingLocation).instructions ?? null;
		default:
			return null;
	}
};

/** Get location type label */
export const getLocationTypeLabel = (location?: Api.IMeetingLocation): string => {
	if (!location?._type) return '-';
	switch (location._type) {
		case Api.MeetingLocation.Virtual:
			return 'Virtual';
		case Api.MeetingLocation.Phone:
			return 'Phone';
		case Api.MeetingLocation.InPerson:
			return 'In Person';
		case Api.MeetingLocation.Other:
			return 'Other';
		default:
			return '-';
	}
};
